import * as React from "react"
import { useRecoilValue } from "recoil"
import { productOverlaySelector } from "../../../../recoil/atoms/product-overlay"
import { ProductImageProps } from "./types"
import SimpleImageSlider from "react-simple-image-slider"
import { brandingSelector } from "../../../../recoil/atoms/room"
import { isRGBAcolor, removeOpacity } from "../../../../util"

const _ProductImage: React.FC<ProductImageProps> = ({
  isSmallScreen,
  width,
  height,
  selectedImages,
  keyForImage
}) => {
  const roomStyles = useRecoilValue(brandingSelector)
  const [index, setIndex] = React.useState(0)
  const { coverImages, variants } = useRecoilValue(productOverlaySelector)
  // @ts-ignore
  const images: string[] =
    variants.length === 0 ? coverImages : coverImages?.map(image => image.src)

  const imageString =
    selectedImages.length === 0 ? images.join("-") : selectedImages.join("-")

  React.useEffect(() => {
    setIndex(prev => ++prev)
  }, [imageString])

  return (
    <>
      {selectedImages.length === 0 ? (
        <SimpleImageSlider
          width={width}
          height={height}
          images={images}
          showBullets={false}
          key={`${keyForImage}-${index}`}
          navSize={isSmallScreen ? 20 : 30}
          navStyle={1}
          navMargin={isSmallScreen ? 0 : 5}
          style={{ margin: isSmallScreen ? "0 auto" : "auto 0px" }}
          showNavs={images.length > 1}
          bgColor={
            roomStyles.badgeBackgroundColor
              ? isRGBAcolor(roomStyles.badgeBackgroundColor)
                ? removeOpacity(roomStyles.badgeBackgroundColor)
                : roomStyles.badgeBackgroundColor
              : "white"
          }
        />
      ) : (
        <SimpleImageSlider
          width={width}
          height={height}
          images={selectedImages}
          showBullets={false}
          navSize={isSmallScreen ? 20 : 30}
          navStyle={1}
          key={`selected-image-${index}`}
          navMargin={isSmallScreen ? 0 : 5}
          style={{ margin: isSmallScreen ? "0 auto" : "auto 0px" }}
          showNavs={selectedImages.length > 1}
          bgColor={
            roomStyles.badgeBackgroundColor
              ? isRGBAcolor(roomStyles.badgeBackgroundColor)
                ? removeOpacity(roomStyles.badgeBackgroundColor)
                : roomStyles.badgeBackgroundColor
              : "white"
          }
        />
      )}
    </>
  )
}

export const ProductImage = _ProductImage
